import React, {Component, Fragment} from 'react'
import {Button, message, Popconfirm, Table} from 'antd'
import moment from 'moment/moment'
import * as _ from 'lodash'
import Dropdowns from '../../../../../api/Dropdowns'
import ContractsApi from '../../../../../api/People/LabourContracts'
import Employees from '../../../../../api/Employees'
import Templates from '../../../../../api/Templates'
import TextColumn from '../../../../../elements/Table/Columns/Text'
import NumberColumn from '../../../../../elements/Table/Columns/Number'
import {sessionItemVal} from '../../../../../modules/Utils'
import UOM from '../../../../../elements/Select/Employee/UOM'
import DropdownColumn from '../../../../../elements/Table/Columns/Dropdown'
import RatesTypeSelect from '../../../../../elements/Select/Employee/RatesType'

class Rates extends Component {
  uuid = moment().unix()

  constructor(props) {
    super(props)
    this.keyAtr = 'id'
    let data = []
    if (!_.isEmpty(_.get(props, 'contract.rates')))
      data = props.contract.rates.map(item => ({...item}))
    data.forEach(i => {
      if (!i[this.keyAtr]) i[this.keyAtr] = (this.uuid++).toString()
    })
    this.cacheData = data.map(item => ({...item}))
    this.state = {
      data,
      fetching: false,
    }
    this.api = new ContractsApi()
    this.companyID = (_.get(props, 'contract.company._id') || '').replace(
      'members/',
      '',
    )
    this.key = props.employee._key
    this.type = props.type
    this.employeesApi = new Employees()
    this.templateApi = new Templates()
  }

  async componentDidMount() {
    await this.fetchRatesTemplate()
  }

  fetchRatesTemplate = async () => {
    if (_.isEmpty(this.state.data)) {
      try {
        this.setState({fetching: true})
        let employeeTemplate = await this.templateApi.read(
          this.companyID,
          'employee',
        )
        let data = employeeTemplate['rates'] || []
        data.forEach(i => {
          if (!i[this.keyAtr]) i[this.keyAtr] = (this.uuid++).toString()
        })
        this.setState({data, fetching: false})
        this.props.updateContract('rates', data)
      } catch (err) {
        message.error(err.errorMessage)
        this.setState({fetching: false})
      }
    }
  }
  dropdownApi = new Dropdowns()
  columns = [
    {
      title: 'Type',
      dataIndex: 'key',
      render: (value, original) => (
        <DropdownColumn
          SelectCmp={RatesTypeSelect}
          value={value}
          record={original}
          column={'key'}
          dataIndex={this.keyAtr}
          onChange={this.handleChange}
        />
      ),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      render: (text, record) => (
        <TextColumn
          onChange={this.handleChange}
          value={text}
          record={record}
          dataIndex={this.keyAtr}
          column={'name'}
        />
      ),
    },
    {
      title: 'Rate',
      dataIndex: 'rate',
      render: (text, record) => (
        <NumberColumn
          onChange={this.handleChange}
          value={text}
          record={record}
          dataIndex={this.keyAtr}
          column={'rate'}
        />
      ),
    },
    {
      title: 'Period',
      dataIndex: 'uom',
      render: (value, record) => (
        <DropdownColumn
          onChange={this.handleChange}
          SelectCmp={UOM}
          display={sessionItemVal('employee_uom_dropdown', value)}
          value={value}
          record={record}
          dataIndex={this.keyAtr}
          column={'uom'}
        />
      ),
    },
    {
      title: 'Operation',
      dataIndex: 'operation',
      render: (text, record) => {
        const {editable} = record
        return (
          <div className="editable-row-operations">
            {editable ? (
              <span>
                <a onClick={() => this.save(record[this.keyAtr])}>Save</a>
                <span className="ant-divider" />
                <Popconfirm
                  title="Sure to cancel?"
                  onConfirm={() => this.cancel(record[this.keyAtr])}>
                  <a>Cancel</a>
                </Popconfirm>
              </span>
            ) : (
              [
                <a onClick={() => this.edit(record[this.keyAtr])}>Edit</a>,
                <span className="ant-divider" />,
                <Popconfirm
                  title="Sure to remove?"
                  onConfirm={() => this.remove(record[this.keyAtr])}>
                  <a>Remove</a>
                </Popconfirm>,
              ]
            )}
          </div>
        )
      },
    },
  ]
  add = () => {
    const newData = [...this.state.data]
    newData.push({[this.keyAtr]: (this.uuid++).toString(), editable: true})
    this.setState({data: newData})
  }
  cancel = key => {
    const newData = [...this.state.data]
    const target = newData.filter(item => key === item[this.keyAtr])[0]
    if (target) {
      Object.assign(
        target,
        this.cacheData.find(item => key === item[this.keyAtr]),
      )
      delete target.editable
      if (
        Object.keys(target).length === 1 &&
        Object.keys(target)[0] === [this.keyAtr]
      )
        this.remove(target[this.keyAtr])
      else this.setState({data: newData})
      this.props.updateContract('rates', newData)
    }
  }
  remove = key => {
    let newData = [...this.state.data]
    newData = newData.filter(item => key !== item[this.keyAtr])
    this.setState({data: newData})
    this.props.updateContract('rates', newData)
  }
  edit = key => {
    const newData = [...this.state.data]
    const target = newData.find(item => key === item[this.keyAtr])
    if (target) {
      target.editable = true
      this.setState({data: newData})
      this.props.updateContract('rates', newData)
    }
  }
  save = key => {
    const newData = [...this.state.data]
    const target = newData.filter(item => key === item[this.keyAtr])[0]
    if (target) {
      delete target.editable
      this.setState({data: newData})
      this.cacheData = newData.map(item => ({...item}))
      this.props.updateContract('rates', newData)
    }
  }
  handleChange = (value, key, column) => {
    const newData = [...this.state.data]
    const target = newData.find(item => key === item[this.keyAtr])
    if (target) {
      target[column] = value
      this.setState({data: newData})
    }
  }

  render() {
    const {type} = this.props
    if (type === 'view')
      this.columns = this.columns.filter(c => c.dataIndex !== 'operation')
    return (
      <Fragment>
        <Table
          title={() => (
            <Fragment>
              <span style={{color: '#1890ff'}}>RATES</span>
              {type !== 'view' && (
                <Button
                  style={{float: 'right'}}
                  size={'small'}
                  onClick={this.add}>
                  Add Rate
                </Button>
              )}
            </Fragment>
          )}
          loading={this.state.fetching}
          pagination={false}
          columns={this.columns}
          dataSource={this.state.data}
          size="small"
          style={{marginTop: 10}}
        />
      </Fragment>
    )
  }
}

export default Rates
